import { t } from 'i18next'
import {isPossiblePhoneNumber, parsePhoneNumber } from 'libphonenumber-js'
import { Button } from 'primereact/button'
import { Tooltip } from 'primereact/tooltip'
import React from 'react'


const isPossibleSwissNumber = (number: string) : boolean => isPossiblePhoneNumber(number, 'CH')
const isPossibleGerNumber = (number: string) :  boolean => isPossiblePhoneNumber(number, 'DE')
const isPossibleUSNumber = (number: string) :  boolean => isPossiblePhoneNumber(number, 'US')



export const isKnownNumberFormat = (phoneNumber:  string) : boolean => {
	return isPossibleGerNumber(phoneNumber) || isPossibleSwissNumber(phoneNumber) 
		|| isPossibleUSNumber(phoneNumber)
}


export const formatPhoneNumber = (phoneNumber : string) : [string, boolean] => {


	if (isPossibleSwissNumber(phoneNumber)) {
		return [parsePhoneNumber(phoneNumber, 'CH').formatInternational(), true]

	}
	if (isPossibleGerNumber(phoneNumber)) {
		return [parsePhoneNumber(phoneNumber, 'DE').formatInternational(), true]
	}
	if (isPossibleUSNumber(phoneNumber)) {
		return [parsePhoneNumber(phoneNumber, 'US').formatInternational(), true]
	}


	return [phoneNumber, false]


}



export const FormattedPhoneNumberTableEntry = (phoneNumber: string): JSX.Element => {

	if (!phoneNumber) {
		return <></>
	}


	// format phone number to display it correct if format is known/handled
	const [formattedPhoneNumber, isFormatted]: [string, boolean] = formatPhoneNumber(phoneNumber)
	let isEmail = false
	if (phoneNumber.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
		isEmail = true
	}
	// if the phone number is not a known format do not format and warn the user
	return <>
		<Tooltip target='.warning-icon' />
		<span>{formattedPhoneNumber}</span>
		{!isEmail  && !isFormatted &&
			<i className={'warning-icon fa-solid fa-exclamation-triangle ml-2 pb-1 pt-1'}
				data-pr-tooltip={t<string>('phone.unknown_format')}
				data-pr-position='left'
				data-pr-showdelay='300'
			/>
		}
		<Button
			className={'p-button-text icon-dark-gray copy-text ml-auto'} type={'button'}
			tooltip={t<string>('core.copy')}
			tooltipOptions={{ position: 'left', showDelay: 500 }}
			icon={'fa-solid fa-copy'}
			onClick={() => navigator.clipboard.writeText(phoneNumber ? phoneNumber : '')}
		/></>
}